import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const alertMessageVariants = cva(
  "p-4 rounded text-sm border transition-all",
  {
    variants: {
      variant: {
        error: "bg-destructive/10 text-destructive border-destructive/20",
        success: "bg-accent/10 text-foreground border-accent/20",
        info: "bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20",
        warning: "bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border-yellow-500/20",
      },
    },
    defaultVariants: {
      variant: "info",
    },
  }
);

export interface AlertMessageProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertMessageVariants> {
  children: React.ReactNode;
}

const AlertMessage = React.forwardRef<HTMLDivElement, AlertMessageProps>(
  ({ className, variant, children, ...props }, ref) => {
    const isError = variant === "error";
    
    return (
      <div
        ref={ref}
        role={isError ? "alert" : "status"}
        aria-live={isError ? "assertive" : "polite"}
        className={cn(alertMessageVariants({ variant }), className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);
AlertMessage.displayName = "AlertMessage";

export { AlertMessage, alertMessageVariants };
